import type { ReactNode } from 'react';

import { Typography } from '../Typography';

type EmptyStateProps = {
  title: string;
  description: string;
  button?: ReactNode;
};

const EmptyState = ({ title, description, button }: EmptyStateProps) => (
  <div className={'flex flex-col items-center justify-center my-10'}>
    <Typography className={'mb-2'} fontFace={'BodyRegularLg'}>
      {title}
    </Typography>

    <Typography className={'text-gray-600'} fontFace={'BodyRegularLg'}>
      {description}
    </Typography>
    {button ? <div className={'mt-6'}>{button}</div> : <></>}
  </div>
);

export { EmptyState };
export type { EmptyStateProps };
